export enum CoAManagedType {
  User = "user",
  Application = "application",
}

export enum SegmentType {
  Fund = "urn:opengov:coa/segment/fund",
  SubFund = "urn:opengov:coa/segment/sub-fund",
  Department = "urn:opengov:coa/segment/department",
  Division = "urn:opengov:coa/segment/division",
  BusinessUnit = "urn:opengov:coa/segment/business-unit",
  Location = "urn:opengov:coa/segment/location",
  Function = "urn:opengov:coa/segment/function",
  Activity = "urn:opengov:coa/segment/activity",
  SubActivity = "urn:opengov:coa/segment/sub-activity",
  Object = "urn:opengov:coa/segment/object",
  Project = "urn:opengov:coa/segment/project",
  ProjectCategory = "urn:opengov:coa/segment/project-category",
  Grant = "urn:opengov:coa/segment/grant",
  Program = "urn:opengov:coa/segment/program",
  Unknown = "urn:opengov:coa/segment/unknown",
}

export enum CoAManagingApplication {
  Financials = "urn:opengov:application:financials",
}

export enum LedgerType {
  Expenses = "expenses",
  Revenues = "revenues",
  Assets = "assets",
  Liabilities = "liabilities",
  Equities = "equities",
  FTECounts = "ftes",
  Uncategorized = "uncategorized",
}

export type ChartOfAccounts = {
  id: string;
  entity_id: number;
  name: string;
  is_default: boolean;
  account_string_separators: string[];
  created_at: string;
  updated_at: string;
  etag: string;
  managed_type: CoAManagedType;
  managing_application?: CoAManagingApplication;
  trees?: CoaTree[]; // Optional - only present when 'trees' is included in the embed
};

export type CoaTree = {
  id: string;
  name: string;
  visible: boolean;
  ledger_type: null | LedgerType;
  categories: string[];
  order: number;
  display_order: number;
  segment_order: number;
  code_depth: number;
  enabled: boolean;
  segment_type: SegmentType;
  node_properties?: { [key: string]: CoaTreeNodeProperty }; // Optional - only present when 'node_properties' is included in the embed
  default_segment_code: null;
};

export type CoaTreeNodeProperty = {
  id: string;
  name: string;
  parent_id?: string;
  category_index: number;
  used?: boolean; // Optional - only present when 'used' is included in the embed
  order?: number; // Optional - only present when 'order' is included in the embed
  children?: string[];
  account_code?: string;
  ignored?: boolean; // Optional - only present when 'ignored' is included in the embed
};

export type CoaEmbedField = "trees" | "node_properties" | "used" | "ignored" | "order";
